import { OrganizationService } from 'src/app/data/service/organization.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  CHAGEBEE_STATUS_REJECT,
  SUBSCRIPTION_DEFAULT_STATUS,
  SUPPORT_EMAIL,
} from 'src/app/utils/const';
import { Organization } from 'src/app/data/model/organization';
import { ShareService } from 'src/app/data/service/share.service';
import { AppAuthGuardService } from 'src/app/data/service/app-auth-guard.service';
import { LoaderService } from 'src/app/layouts/loader-chargebee/loader.service';
import { environment } from 'src/environments/environment';
export const CheckSubscriptionGuard = () => {
  const shareService = inject(ShareService);
  const organizationService = inject(OrganizationService);
  const loaderService = inject(LoaderService);
  const router = inject(Router);
  const authGuard = inject(AppAuthGuardService);
  const subscriptionDefaultStatus = SUBSCRIPTION_DEFAULT_STATUS;
  const chargebeeStatusReject = CHAGEBEE_STATUS_REJECT;
  const session = shareService.getSession();
  const currentUser = session.currentUser;
  const supportEmail = SUPPORT_EMAIL;
  let hasAccess = false;

  if (currentUser.email == supportEmail) {
    return true;
  }

  // await organizationService.checkSubscription(shareService.organizationSelected?.id).toPromise().then((response: Organization) => {
  //    console.log("ici 111111");
  //     if (response.chargebeeSubscriptionStatus == subscriptionDefaultStatus) {
  //     console.log("ici 222222");
  //       hasAccess = true;
  //     } else {
  //     console.log('ici 333333');

  //       if (!chargebeeStatusReject.includes(response.chargebeeSubscriptionStatus)) {
  //     console.log('ici 4444444');
  //     hasAccess = true;
  //       }
  //     }

  //     console.log('ici 5555555');
  //     if (hasAccess) {
  //     console.log('ici 66666666');
  //     return true;
  //     } else {
  //     console.log('ici 777777777777');
  //     router.navigateByUrl('/unauthorized/subscription');
  //       return false;
  //     }
  // }).catch(() => {
  //   console.log('ici 888888888888');
  //   router.navigateByUrl('/unauthorized/subscription');
  //   return false;
  // })
  if (session && shareService?.organizationSelected?.id) {
    organizationService
      .checkSubscription(shareService.organizationSelected?.id)
      .subscribe(
        async (response: Organization) => {
          const status = response.chargebeeSubscriptionStatus;
          const plan = response.subscriptionType.toLowerCase();

          if (environment.isDks) {
            if (!plan.includes('free')) {
              if (status == subscriptionDefaultStatus || status == '') {
                if (authGuard.hasOrganizationRoles('super_admin')) {
                  const currentPath = window.location.origin + '/dashboard';
                  loaderService.show();
                  const hostedPage = await organizationService.askHostedPageForCreateSubscriptionFromChargebee(
                    currentPath,
                    shareService?.organizationSelected
                  ).toPromise().catch((error) => {
                    return false;
                  });

                  if (!hostedPage) {
                    hasAccess = false;
                  }else{
                    window.location.replace(hostedPage.url);
                  }
                  loaderService.hide();
                } else {
                  hasAccess = false;
                }
              }
            }
          }
          if (status == subscriptionDefaultStatus) {
            hasAccess = true;
          } else {
            if (!chargebeeStatusReject.includes(status)) {
              hasAccess = true;
            }
          }

          if (hasAccess) {
            return true;
          } else {
            router.navigateByUrl('/unauthorized/subscription');
            return false;
          }
        },
        (error: any) => {
          router.navigateByUrl('/unauthorized/subscription');
          return false;
        }
      );
  }
};
